import { AuthOptions } from '@aws-amplify/auth/lib-esm/types'

const awsConfig: AuthOptions = {
  region: 'ca-central-1',
  userPoolId: '',
  userPoolWebClientId: '',
}

export default awsConfig
